import { render } from "./productHub.vue?vue&type=template&id=d59c9272&scoped=true"
import script from "./productHub.vue?vue&type=script&lang=js"
export * from "./productHub.vue?vue&type=script&lang=js"

import "./productHub.vue?vue&type=style&index=0&id=d59c9272&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59c9272"]])

export default __exports__